import { memo } from "react";
import { connect } from "react-redux";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({children , token})=>{
    return token || localStorage.getItem('token') ? children : <Navigate to="/Login" />
}
const mapStateToProps = (state) => {
    return {
      token: state.token,
    };
  };
export default connect(mapStateToProps)(memo(ProtectedRoute));